/**
 * `@quadratic/editor` (architecture §11): the shared rich-text schema, `validateDoc`, the read-only React renderer
 * and the server renderers (plain text, Markdown, email HTML), each label-producing one taking a LabelResolver.
 */
export { editorSchema, MARK_ATTRS, NODE_ATTRS, CODE_LANGUAGES, MENTION_KINDS, type MentionKind } from './schema/index';
export { EMPTY_DOC, fileRefs, mentionSet, walk, type DocJSON, type MarkJSON, type Reference } from './doc';
export { safeHref } from './links';
export {
  BODY_MAX_BYTES,
  COMMENT_MAX_BYTES,
  resolveReferences,
  validateDoc,
  validateStructure,
  type DocValidationError,
  type ReferenceChecker,
  type ResolvedDoc,
  type StructureOptions,
  type ValidateDocOptions,
} from './validate';
export { PRIVATE_LABEL, resolveMention, toPlainText, type LabelResolver } from './text';
export { toMarkdown } from './markdown';
export { escapeHtml, toEmailHtml } from './email-html';
export { renderDocToReact, type RenderOptions } from './render-react';
